import { Link } from "react-router-dom";
import { LEGAL_LAST_UPDATED, LEGAL_LINKS, OPERATOR } from "@/lib/legal";
import { tw } from "@/lib/theme";

interface LegalLayoutProps {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
}

export function LegalLayout({ title, subtitle, children }: LegalLayoutProps) {
  return (
    <div className={`min-h-dvh ${tw.canvas}`}>
      <header className="border-b border-border bg-surface dark:border-dark-border dark:bg-dark-surface">
        <div className="flex items-center justify-between gap-4 px-4 py-4">
          <Link
            to="/"
            className="text-lg font-bold text-primary dark:text-primary-dark"
          >
            {OPERATOR.product}
          </Link>
          <nav className="hidden flex-wrap justify-end gap-x-4 gap-y-1 text-xs min-[480px]:flex">
            {LEGAL_LINKS.slice(0, 5).map((link) => (
              <Link key={link.to} to={link.to} className={tw.link}>
                {link.label}
              </Link>
            ))}
          </nav>
        </div>
      </header>

      <main className="px-4 py-8">
        <div className="mb-8 space-y-2">
          <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
          {subtitle ? (
            <p className={`text-sm ${tw.muted}`}>{subtitle}</p>
          ) : null}
          <p className={`text-xs ${tw.muted}`}>Last updated: {LEGAL_LAST_UPDATED}</p>
        </div>

        <article className={`space-y-8 p-5 ${tw.card}`}>{children}</article>

        <footer className="mt-10 space-y-4 border-t border-border pt-8 dark:border-dark-border">
          <p className={`text-center text-xs ${tw.muted}`}>
            © {new Date().getFullYear()} {OPERATOR.product} · Operated by{" "}
            {OPERATOR.name}
          </p>
          <nav className="flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs">
            {LEGAL_LINKS.map((link) => (
              <Link key={link.to} to={link.to} className={tw.link}>
                {link.label}
              </Link>
            ))}
            <Link to="/child-safety" className={tw.link}>
              Child safety
            </Link>
            <Link to="/copyright" className={tw.link}>
              Copyright
            </Link>
            <Link to="/payments" className={tw.link}>
              Payments
            </Link>
            <Link to="/ads" className={tw.link}>
              Ads
            </Link>
            <Link to="/data-deletion" className={tw.link}>
              Data deletion
            </Link>
            <Link to="/cookies" className={tw.link}>
              Cookies
            </Link>
            <Link to="/press" className={tw.link}>
              Press
            </Link>
          </nav>
        </footer>
      </main>
    </div>
  );
}
